export default function SolidColour({ cue }) {
	return (
		<div
			className={`w-screen h-screen
    `}
			style={{
				background: cue?.colour,
			}}
		></div>
	);
}
